import React from "react";

const ContactUs = () => {
  return (
    <div
      className="container text-center"
      style={{
        backgroundColor: "#ffe5b4",
        padding: "30px",
        borderRadius: "10px",
        marginTop: "20px",
      }}
    >
      <h2 style={{ color: "#ff5733", marginBottom: "20px" }}>Contact Us</h2>

      <p style={{ fontSize: "1.1rem", color: "#333", maxWidth: "600px", margin: "0 auto" }}>
        If you have any questions, feedback, or need assistance, feel free to reach out to us. We're here to help and will get back to you as soon as possible.
      </p>

      <div className="d-flex justify-content-center flex-wrap mt-4 gap-3">
        {/* Contact Person 1 */}
        <div
          className="card"
          style={{
            backgroundColor: "#ff5733",
            borderRadius: "10px",
            padding: "20px",
            color: "white",
            width: "250px",
          }}
        >
          <h5>Vaibhav Chaturvedi </h5>
          <p style={{ marginBottom: "5px" }}>Email: info@samriddhihealth.com</p>
          <p>Phone: +91 98070 01718</p>
        </div>

        {/* Contact Person 2 */}
        <div
          className="card"
          style={{
            backgroundColor: "#ff5733",
            borderRadius: "10px",
            padding: "20px",
            color: "white",
            width: "250px",
          }}
        >
          <h5>Dev</h5>
          <p style={{ marginBottom: "5px" }}>Email: info@samriddhihealth.com</p>
          <p>Phone: +91 63928 33852</p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
